
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/merchants/merchant",
      function () {
        return require("private-next-pages/merchants/merchant.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/merchants/merchant"])
      });
    }
  